export default __webpack_public_path__ + "static/media/6.68fa4196.jpg";